// @flow
import $ from 'jquery';
import JQueryView from '../common/JQueryView';

export default class AlertView extends JQueryView {
  constructor() {
    super('.show-alert');
    this.render();
  }

  get $alert() {
    return this.$el.find('.alert').last();
  }

  dismissAlert = () => {
    this.$alert.fadeTo(2000, 500).slideUp(500);
    if ($('.modal.show').length > 0) $('.modal.show').focus();
  };

  render() {
    this.dismissAlert();
  }
}
